import React, { useState } from 'react';
import '../styles/Description.css';

function Description(props) {
    const [showMore, setShowMore] = useState(false);
    const property = props.property;
    const charLimit = 280;
    const truncatedDescription = property.listingDetails.listingDescription === null ? null
    :
    showMore === false &&
        property.listingDetails.listingDescription.length > charLimit
    ? 
    property.listingDetails.listingDescription.substring(0, charLimit) + '...'
    : 
    property.listingDetails.listingDescription;

    const toggleShowMore = () => {
        setShowMore(!showMore);
    };

    return (
        <div className="description-container">
            <span className="body-regular colour-primary">
                {truncatedDescription}
            </span>
            {
                showMore === false && property.listingDetails.listingDescription.length > charLimit ?
                <span 
                    className="body-bold colour-primary underline cursor-pointer"
                    onClick={() => toggleShowMore()}
                >
                    Show more
                </span>
                :
                showMore === true && property.listingDetails.listingDescription.length > charLimit ?
                <span 
                    className="body-bold colour-primary underline cursor-pointer"
                    onClick={() => toggleShowMore()}
                >
                    Show less
                </span>
                :
                null
            }
        </div>
    )
};

export default Description;